import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import auth from './stores/auth'
import estado from './stores/estado'
import regiao from './stores/regiao'
import cidade from './stores/cidade'
import usuario from './stores/usuario'
import tecnico from './stores/tecnico'
import cliente from './stores/cliente'
import industria from './stores/industria'
import email from './stores/email'
import telefone from './stores/telefone'
import clienteIndustria from './stores/cliente.industria'
import visita from './stores/visita'
import balancete from './stores/balancete'
import laudo from './stores/laudo'
import relatorio from './stores/relatorio'
import responsavel from './stores/responsavel'
import pendencia from './stores/pendencia'
import controle from './stores/controle'
import evento from './stores/evento'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['auth']
})

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    estado,
    regiao,
    cidade,
    usuario,
    tecnico,
    cliente,
    industria,
    email,
    telefone,
    clienteIndustria,
    visita,
    balancete,
    laudo,
    relatorio,
    responsavel,
    pendencia,
    controle,
    evento
  },
  plugins: [vuexLocal.plugin]
})
